import { FileDownload } from '@shared/http';

import { NetCostComparisonRoot, PackagingNetCostComparison, TagNetCostComparison } from '@/features/bid-analysis/types/net-cost-comparison';
import { artiaProtectedApi } from '@/lib/api-client';
import { downloadFile, putWithValidation } from '@/lib/api-helpers';

export const useNetCostComparisonService = (bidAnalysisId: number) => {
  const updateNetCostComparisonPackaging = async (
    packagingId: number,
    { pharmacyReimbursementUnit }: { pharmacyReimbursementUnit: number | null }
  ): Promise<PackagingNetCostComparison> => {
    return await putWithValidation<PackagingNetCostComparison>(
      `bid-analyses/${bidAnalysisId}/net-cost-comparison/packagings/${packagingId}`,
      { data: { pharmacyReimbursementUnit } }
    );
  };

  const getInitialView = (): Promise<NetCostComparisonRoot> => {
    return artiaProtectedApi.get(`bid-analyses/${bidAnalysisId}/net-cost-comparison`);
  };

  const expandProduct = (stateCode: string, productId: number, tagId?: number): Promise<ExpandProductResponse> => {
    if (tagId) {
      return artiaProtectedApi.get(`bid-analyses/${bidAnalysisId}/net-cost-comparison/states/${stateCode}/tags/${tagId}`);
    }

    return artiaProtectedApi.get(`bid-analyses/${bidAnalysisId}/net-cost-comparison/states/${stateCode}/drugs/${productId}`);
  };

  const exportToCsv = (): Promise<FileDownload> => {
    return downloadFile('POST', `bid-analyses/${bidAnalysisId}/export`);
  };

  return {
    getInitialView,
    exportToCsv,
    updateNetCostComparisonPackaging,
    expandProduct
  };
};

type ExpandProductResponse = {
  tags?: TagNetCostComparison[];
  packagings?: PackagingNetCostComparison[];
};
